import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useTaskCache } from '../task'
import { useEventCache } from './cache'
import {
  type CalendarEventData,
  Logger,
  CURRENT_VERSION,
  toResponseError,
  type CalendarEventUpdateInput,
  type CalendarEventUpdateSuccess,
} from '@terros/common'

const logger = new Logger('calendar-update')
logger.level = 'verbose'

export function useUpdateCalendarEvent(): UpdateHookResponse<CalendarEventUpdateInput['event'], CalendarEventData> {
  const { replaceItem, clearList } = useEventCache()
  const { clearList: clearTaskList } = useTaskCache()
  const mutation = useTantalimMutation<CalendarEventUpdateInput, CalendarEventUpdateSuccess>({
    url: '/calendar/event/update',
  })

  async function update(event: CalendarEventUpdateInput['event']): Promise<CalendarEventData> {
    try {
      const output = await mutation.mutateAsync({ version: CURRENT_VERSION, event })
      replaceItem(output.event)
      logger.verbose('clearing event list')
      clearList()
      logger.verbose('clearing task list')
      clearTaskList()
      logger.info('update succeeded', output.event)
      return output.event
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
